function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, chat_mod) {
  var html = "<div id=\"saito-chats-modal\" class=\"saito-modal\">\n                <div class=\"saito-modal-title\">My Chats</div>\n                <div class=\"saito-modal-content saito-menu-select-heavy\">\n              ";
  var _iterator = _createForOfIteratorHelper(chat_mod.groups),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var group = _step.value;
      var identicon_source = group.id;
      if (group.members.length == 2) {
        var _iterator2 = _createForOfIteratorHelper(group.members),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mem = _step2.value;
            if (mem !== chat_mod.publicKey) {
              identicon_source = mem;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var imgsrc = app.keychain.returnIdenticon(identicon_source);
      var shared = '';
      if (app.keychain.hasSharedSecret(identicon_source)) {
        shared = "<i class=\"fa-solid fa-lock secure-contact-notice\"></i>";
      }
      html += "\n\t\t\t <div class=\"saito-contact\" data-id=\"".concat(group.id, "\">\n\t\t\t <div class=\"saito-user\" data-id=\"").concat(group.id, "\" data-disable=\"true\">\n\t\t\t    ").concat(shared, "\n\t\t\t    <div class=\"saito-identicon-box\">\n\t\t\t      <img class=\"saito-identicon\" src=\"").concat(imgsrc, "\" data-disable=\"true\"/>\n\t\t\t    </div>\n\t\t\t    <div class=\"saito-address saito-address-long\" data-id=\"").concat(app.browser.escapeHTML(group.name), "\" data-disable=\"true\">").concat(app.browser.escapeHTML(group.name), "</div>\n\t\t\t    <div class=\"saito-userline\">").concat(group.txs.length, " messages</div>    \n\t\t\t  </div>\n\t\t\t </div>");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += '</div></div>';
  return html;
};